<template>
  <div>
    <ca-heading text="Gerar Seguro Desemprego" />

    <ca-page>
      <ca-form
        :on-submit="onSubmit"
        :on-submit-success="onSubmitSuccess"
        :on-submit-error="onSubmitError"
        :error-message="errorMessage">
        <ca-row>
          <ca-col offset="3" size="6">
            <ca-field label="Mês">
              <ca-monthpicker v-model="selectedDate"></ca-monthpicker>
            </ca-field>
          </ca-col>
        </ca-row>

        <ca-footer>
          <ca-row vertical-offset="2">
            <ca-col offset="10" size="2">
              <ca-submit-button>
                Gerar
              </ca-submit-button>
            </ca-col>
          </ca-row>
        </ca-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import moment from 'moment';
import { getBoxInformationErrorMessage } from 'packages/common/utils';
import { downloadFile } from 'packages/common/utils/file';
import { generateUnemploymentInsurance } from './unemploymentInsuranceService';

export default {
  name: 'UnemploymentInsuranceFormPage',
  data() {
    return {
      selectedDate: moment().format('DD/MM/YYYY'),
      errorMessage: null,
    };
  },
  methods: {
    onSubmit() {
      return generateUnemploymentInsurance(this.selectedDate);
    },
    onSubmitSuccess(response) {
      downloadFile(response.file, response.fileName);
      this.$toaster.success('Seguro desemprego gerado com sucesso');
    },
    onSubmitError(error) {
      this.errorMessage = getBoxInformationErrorMessage(error);
    },
  },
};
</script>
